// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loupe_eye-dropper_\\[fullhash\\] {\n    position: absolute;\n    border-radius: 100%;\n    border: 1px solid #222;\n}\n", "",{"version":3,"sources":["webpack://./../paint/src/components/loupe/loupe.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B","sourcesContent":[".eye-dropper {\n    position: absolute;\n    border-radius: 100%;\n    border: 1px solid #222;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eye-dropper": "loupe_eye-dropper_[fullhash]",
	"eyeDropper": "loupe_eye-dropper_[fullhash]"
};
export default ___CSS_LOADER_EXPORT___;
